export const API_BASE = (() => {
  if (typeof window === 'undefined') return 'http://127.0.0.1:8010';

  const hostname = window.location.hostname;
  const port = window.location.port;

  if (hostname === 'localhost' || hostname === '127.0.0.1' || port === '3000') {
    return 'http://127.0.0.1:8010';
  }

  return '/backend';
})();

console.log('🌐 API_BASE detectado:', API_BASE);

export const getFileUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;

  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return encodeURI(`${API_BASE}${cleanPath}`);
};


let currentUser = JSON.parse(localStorage.getItem("currentUser")) || null;

export function login(username, token, rol) {
  currentUser = { username, token, rol: String(rol || "") };
  localStorage.setItem("currentUser", JSON.stringify(currentUser));
}

export function logout() {
  currentUser = null;
  localStorage.removeItem("currentUser");
}

export function getHeaders(extraHeaders = {}) {
  if (!currentUser) throw new Error("Usuario no autenticado. Haz login primero.");
  return {
    "Authorization": `Bearer ${currentUser.token}`,
    ...extraHeaders,
  };
}

async function handleResponse(res, context = "") {
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Error ${context ? context + ": " : ""}${res.status} - ${text}`);
  }
  try {
    return await res.json();
  } catch {
    return {};
  }
}

export async function listarAlmacen() {
  return handleResponse(
    await fetch(`${API_BASE}/almacen/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "listando almacén"
  );
}

export async function crearItem(data) {
  return handleResponse(
    await fetch(`${API_BASE}/almacen/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(data),
    }),
    "creando ítem de almacén"
  );
}

export async function actualizarItem(id, data) {
  if (!id) throw new Error("ID del item es obligatorio para actualizar");
  return handleResponse(
    await fetch(`${API_BASE}/almacen/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(data),
    }),
    "actualizando ítem de almacén"
  );
}

export async function borrarItem(id) {
  if (!id) throw new Error("ID del item es obligatorio para eliminar");
  return handleResponse(
    await fetch(`${API_BASE}/almacen/${id}`, {
      method: "DELETE",
      headers: {
        ...getHeaders(),
      },
    }),
    "borrando ítem"
  );
}

export async function listarVehiculos() {
  return handleResponse(
    await fetch(`${API_BASE}/vehiculos/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "listando vehículos"
  );
}

export async function crearVehiculo(data) {
  return handleResponse(
    await fetch(`${API_BASE}/vehiculos/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(data),
    }),
    "creando vehículo"
  );
}

export async function actualizarVehiculo(id, data) {
  if (!id) throw new Error("ID del vehículo es obligatorio");
  return handleResponse(
    await fetch(`${API_BASE}/vehiculos/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(data),
    }),
    "actualizando vehículo"
  );
}

export async function borrarVehiculo(id) {
  if (!id) throw new Error("ID del vehículo es obligatorio");
  return handleResponse(
    await fetch(`${API_BASE}/vehiculos/${id}`, {
      method: "DELETE",
      headers: {
        ...getHeaders(),
      },
    }),
    "borrando vehículo"
  );
}

export async function listarMaquinaria() {
  return handleResponse(
    await fetch(`${API_BASE}/maquinaria/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "listando maquinaria"
  );
}

export async function crearMaquinaria(data) {
  return handleResponse(
    await fetch(`${API_BASE}/maquinaria/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(data),
    }),
    "creando maquinaria"
  );
}

export async function actualizarMaquinaria(id, data) {
  if (!id) throw new Error("ID de la maquinaria es obligatorio");

  if (data.horas_actuales_maquinaria !== undefined) {
    data.horas_actuales = data.horas_actuales_maquinaria;
    delete data.horas_actuales_maquinaria;
  }

  return handleResponse(
    await fetch(`${API_BASE}/maquinaria/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(data),
    }),
    "actualizando maquinaria"
  );
}

export async function borrarMaquinaria(id) {
  if (!id) throw new Error("ID de la maquinaria es obligatorio");
  return handleResponse(
    await fetch(`${API_BASE}/maquinaria/${id}`, {
      method: "DELETE",
      headers: {
        ...getHeaders(),
      },
    }),
    "borrando maquinaria"
  );
}

export async function listarUtillaje() {
  return handleResponse(
    await fetch(`${API_BASE}/utillaje/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "listando utillaje"
  );
}

export async function crearUtillaje(data) {
  return handleResponse(
    await fetch(`${API_BASE}/utillaje/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(data),
    }),
    "creando utillaje"
  );
}

export async function actualizarUtillaje(id, data) {
  if (!id) throw new Error("ID del utillaje es obligatorio");

  if (data.horas_actuales_utillaje !== undefined) {
    data.horas_actuales = data.horas_actuales_utillaje;
    delete data.horas_actuales_utillaje;
  }

  return handleResponse(
    await fetch(`${API_BASE}/utillaje/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(data),
    }),
    "actualizando utillaje"
  );
}

export async function borrarUtillaje(id) {
  if (!id) throw new Error("ID del utillaje es obligatorio");
  return handleResponse(
    await fetch(`${API_BASE}/utillaje/${id}`, {
      method: "DELETE",
      headers: {
        ...getHeaders(),
      },
    }),
    "borrando utillaje"
  );
}

export async function listarMantenimientos() {
  return handleResponse(
    await fetch(`${API_BASE}/mantenimientos/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "listando mantenimientos"
  );
}

export async function obtenerMantenimiento(id) {
  return handleResponse(
    await fetch(`${API_BASE}/mantenimientos/${id}`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "obteniendo mantenimiento"
  );
}

export async function crearMantenimiento(data) {
  return handleResponse(
    await fetch(`${API_BASE}/mantenimientos/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(data),
    }),
    "creando mantenimiento"
  );
}

export async function actualizarMantenimiento(id, data) {
  return handleResponse(
    await fetch(`${API_BASE}/mantenimientos/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(data),
    }),
    "actualizando mantenimiento"
  );
}

export async function borrarMantenimiento(id) {
  if (!id) throw new Error("ID del mantenimiento es obligatorio");
  return handleResponse(
    await fetch(`${API_BASE}/mantenimientos/${id}`, {
      method: "DELETE",
      headers: {
        ...getHeaders(),
      },
    }),
    "borrando mantenimiento"
  );
}

export async function listarDetallesMantenimiento(mantenimiento_id) {
  return handleResponse(
    await fetch(`${API_BASE}/mantenimientos/${mantenimiento_id}/detalle/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "listando detalles del mantenimiento"
  );
}

export async function agregarDetalleMantenimiento(
  mantenimiento_id,
  almacen_id,
  cantidad_usada
) {
  const payload = {
    almacen_id: Number(almacen_id),
    cantidad_usada: Number(cantidad_usada),
  };
  return handleResponse(
    await fetch(`${API_BASE}/mantenimientos/${mantenimiento_id}/detalle/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify(payload),
    }),
    "agregando detalle de mantenimiento"
  );
}

export async function borrarDetalleMantenimiento(mantenimiento_id, detalle_id) {
  return handleResponse(
    await fetch(`${API_BASE}/mantenimientos/${mantenimiento_id}/detalle/${detalle_id}`, {
      method: "DELETE",
      headers: {
        ...getHeaders(),
      },
    }),
    "borrando detalle de mantenimiento"
  );
}

export async function materialesVehiculo(vehiculo_id) {
  return handleResponse(
    await fetch(`${API_BASE}/vehiculos/${vehiculo_id}/materiales/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "materiales del vehículo"
  );
}

export async function materialesMaquinaria(maquinaria_id) {
  return handleResponse(
    await fetch(`${API_BASE}/maquinaria/${maquinaria_id}/materiales/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "materiales de maquinaria"
  );
}

export async function materialesUtillaje(utillaje_id) {
  return handleResponse(
    await fetch(`${API_BASE}/utillaje/${utillaje_id}/materiales/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "materiales de utillaje"
  );
}

export async function listarArchivosEquipo(tipo, equipo_id) {
  const data = await handleResponse(
    await fetch(`${API_BASE}/equipos/${tipo}/${equipo_id}/archivos/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "listando archivos de equipo"
  );
  return data.map((f) => ({
    id: f.id,
    nombre: f.nombre || "Archivo sin nombre",
    ruta: f.ruta,
    creado: f.creado,
  }));
}

export async function subirArchivoEquipo(tipo, equipo_id, archivo) {
  const formData = new FormData();
  formData.append("archivo", archivo);
  return handleResponse(
    await fetch(`${API_BASE}/equipos/${tipo}/${equipo_id}/archivos/`, {
      method: "POST",
      body: formData,
      headers: {
        ...getHeaders(),
      },
    }),
    "subiendo archivo de equipo"
  );
}

export async function eliminarArchivoEquipo(tipo, archivo_id) {
  return handleResponse(
    await fetch(`${API_BASE}/equipos/${tipo}/archivos/${archivo_id}`, {
      method: "DELETE",
      headers: {
        ...getHeaders(),
      },
    }),
    "eliminando archivo"
  );
}

export async function listarArchivosMantenimiento(mantenimiento_id) {
  const data = await handleResponse(
    await fetch(`${API_BASE}/mantenimientos/${mantenimiento_id}/archivos/`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "listando archivos del mantenimiento"
  );
  return data.map((f) => ({
    id: f.id,
    nombre: f.nombre || "Archivo sin nombre",
    ruta: f.ruta,
    creado: f.creado,
  }));
}

export async function subirArchivoMantenimiento(mantenimiento_id, archivo) {
  const formData = new FormData();
  formData.append("archivo", archivo);
  return handleResponse(
    await fetch(`${API_BASE}/mantenimientos/${mantenimiento_id}/archivos/`, {
      method: "POST",
      body: formData,
      headers: {
        ...getHeaders(),
      },
    }),
    "subiendo archivo de mantenimiento"
  );
}

export async function eliminarArchivoMantenimiento(archivo_id) {
  return handleResponse(
    await fetch(`${API_BASE}/mantenimientos/archivos/${archivo_id}`, {
      method: "DELETE",
      headers: {
        ...getHeaders(),
      },
    }),
    "eliminando archivo de mantenimiento"
  );
}

export async function listarUsuarios() {
  return handleResponse(
    await fetch(`${API_BASE}/usuarios`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "listando usuarios"
  );
}

export async function crearUsuario(username, password, rol) {
  return handleResponse(
    await fetch(`${API_BASE}/usuarios`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify({ username, password, rol }),
    }),
    "creando usuario"
  );
}

export async function actualizarUsuario({ username, password, rol }) {
  const encoded = encodeURIComponent(username);
  return handleResponse(
    await fetch(`${API_BASE}/usuarios/${encoded}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      body: JSON.stringify({ password, rol }),
    }),
    "actualizando usuario"
  );
}

export async function borrarUsuario(username) {
  const encoded = encodeURIComponent(username);
  return handleResponse(
    await fetch(`${API_BASE}/usuarios/${encoded}`, {
      method: "DELETE",
      headers: {
        ...getHeaders(),
      },
    }),
    "borrando usuario"
  );
}

export async function subirImagenPrincipal(tipo, equipoId, file) {
  const formData = new FormData();
  formData.append("imagen", file);

  return handleResponse(
    await fetch(`${API_BASE}/equipos/${tipo}/${equipoId}/imagen/`, {
      method: "POST",
      headers: {
        ...getHeaders(),
      },
      body: formData,
    }),
    "subiendo imagen principal"
  );
}

export async function buscarEquipoPorReferencia(ref) {
  return handleResponse(
    await fetch(`${API_BASE}/equipos/referencia/${ref}`, {
      headers: {
        ...getHeaders(),
      },
    }),
    "buscando equipo por referencia"
  );
}

export async function autenticarUsuario(username, password) {
  const res = await fetch(`${API_BASE}/usuarios/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      username: (username || "").trim(),
      password: (password || "").trim()
    }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Error de autenticación");
  }

  const data = await res.json();
  login((username || "").trim(), data.access_token, data.rol);
  return data.rol;
}
